<mat-drawer-container hasBackdrop>
  <mat-drawer autoFocus="false" #drawer mode="over" position="end">
    <app-right-sidebar-container
      [title]="isEditing ? 'Update' : 'Create' + ' Product'"
      [footerSubmitCustomLabel]="isEditing ? 'Update' : 'Create'"
      (cancel)="close()"
      (submit)="onSubmit()"
      [disableSubmit]="form.invalid || form.pending"
      >
      <form [formGroup]="form" class="provider-content">
        <div class="custom-form-field">
          <label for="lenderIds">Product Name<span class="required">*</span></label>
          <mat-form-field appearance="outline" class="custom-field">
            <input formControlName="name" matInput name="name" />
            @if (form.controls['name'].errors?.['required']) {
              <mat-error>
                Please insert Product name
              </mat-error>
            }
            @if (form.controls['name'].errors?.['entityExists']) {
              <mat-error>
                Product already exist with this name
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="custom-form-field">
          <label for="acronym">Product Acronym<span class="required">*</span></label>
          <mat-form-field appearance="outline" class="custom-field">
            <input formControlName="acronym" matInput name="acronym" />
            @if (form.controls['acronym'].errors?.['required']) {
              <mat-error>
                Please insert Product Acronym
              </mat-error>
            }
            @if (form.controls['acronym'].errors?.['acronymExists']) {
              <mat-error>
                Product already exist with this acronym
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="custom-form-field">
          <label for="notes">Product Description<span class="required">*</span></label>
          <mat-form-field
            appearance="outline"
            class="custom-field textarea no-hint"
            >
            <textarea
              formControlName="description"
              matInput
              name="description"
              rows="3"
            ></textarea>
          </mat-form-field>
          @if (form.controls['description'].touched && form.controls['description'].errors?.['required']) {
            <mat-error
              >
              Please enter Product description
            </mat-error>
          }
        </div>
      </form>
    </app-right-sidebar-container>
  </mat-drawer>
  <mat-drawer-content>
    <div class="pcs-container">
      <div class="pcs-header">
        <h3 class="pcs-title">Products List</h3>
        @if (!isProvider() && !isConsultant() && !isProviderReadOnly()) {
          <div class="card-actions">
            <button
              (click)="openRightSidebar()"
              mat-flat-button
              color="primary"
              type="button"
              >
              <mat-icon>add</mat-icon> Create
            </button>
          </div>
        }
      </div>
      <app-search-sort
        [searchControl]="searchControl"
        [sortForm]="sortForm"
        [sortOptions]="sortOptions"
        (apply)="setSortField()"
        (close)="resetSortField()"
      ></app-search-sort>
      <div class="pro-card col">
        <app-ag-grid-wrapper
          [data]="rowData"
          [columns]="columnDefs"
          (ready)="onGridReady($event)"
          />
          <mat-paginator
            #paginator
            [selectConfig]="{ panelClass: 'mat-paginator-select-options' }"
            [length]="totalCount"
            [pageIndex]="currentPage"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSettings.pageSizeOptions"
            (page)="handlePageEvent($event)"
            aria-label="Select page"
            >
          </mat-paginator>
        </div>


      </div>
    </mat-drawer-content>
  </mat-drawer-container>
